import Page from './Page';

import hoc from '!app/hoc';

export default hoc(Page);
